import { render, staticRenderFns } from "./ListChart.vue?vue&type=template&id=4b8f620e&scoped=true&"
import script from "./ListChart.vue?vue&type=script&lang=ts&"
export * from "./ListChart.vue?vue&type=script&lang=ts&"
import style0 from "./ListChart.vue?vue&type=style&index=0&id=4b8f620e&lang=scss&scoped=true&"
import style1 from "./ListChart.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8f620e",
  null
  
)

export default component.exports